import GoogleAnalytics from './google_analytics'
export default GoogleAnalytics



// WEBPACK FOOTER //
// ./src/plugins/google_analytics/index.js